export const options = {
  chart: {
    height: 320,
    type: 'line',
    zoom: { enabled: false },
    toolbar: { show: false },
    background: 'transparent',
    fontFamily: 'Source Sans 3, system-ui, sans-serif',
  },
  theme: { mode: 'dark' },
  colors: ['#818cf8'],
  dataLabels: { enabled: false },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Reserve / swap series',
    align: 'left',
    style: {
      color: '#94a3b8',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
  grid: {
    borderColor: 'rgba(148, 163, 184, 0.12)',
    strokeDashArray: 4,
    row: {
      colors: ['transparent', 'transparent'],
      opacity: 0.5,
    },
  },
  xaxis: {
    labels: { style: { colors: '#64748b' } },
    axisBorder: { color: 'rgba(148, 163, 184, 0.12)' },
    axisTicks: { color: 'rgba(148, 163, 184, 0.12)' },
  },
  yaxis: {
    labels: { style: { colors: '#64748b' } },
  },
  tooltip: {
    theme: 'dark',
  },
  legend: {
    labels: { colors: '#94a3b8' },
  },
};

// Placeholder until on-chain swap series is available from the selector
export const series = [
  {
    name: 'Series',
    data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
  },
];
